import { NativeDateAdapter } from "@angular/material";

export class AgentiDateAdapter extends NativeDateAdapter{
    createDate(year:number,month:number,date:number):Date{
        let baseDate = super.createDate(year,month,date);
        let tzo=baseDate.getTimezoneOffset();
        if(tzo!=0){
            baseDate.setMinutes(-tzo);
        }
        return baseDate;
    }
    // getDate(date:Date):number{
    //     return super.getDate(date);
    // }
    parse(value:any):Date|null{
        //super.getDate()
        if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
            const str = value.split('/');
            return new Date(Number(str[2]), Number(str[1])-1, Number(str[0]), 12);
          }
          const timestamp = typeof value === 'number' ? value : Date.parse(value);
          return isNaN(timestamp) ? null : new Date(timestamp);
    }
}


// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/agenti-date-adapter.ts